// extracted by mini-css-extract-plugin
module.exports = {"dashboard-header":"DashboardHeader-module__dashboard-header___28fJL"};